/**
 * EliorGroup.Joyfood.Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ApplicationIntegrationArticlePriceDto } from './applicationIntegrationArticlePriceDto';


export interface ApplicationIntegrationOrderItemDto { 
    id?: number | null;
    articleName?: string | null;
    quantity?: number | null;
    unitPrice?: number | null;
    unitPointCost?: number | null;
    articlePrice?: ApplicationIntegrationArticlePriceDto;
}

